module.exports = __webpack_public_path__ + "static/k3-ff5edfeb942c0347084fe1ecf46facd8.png";